// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_2HR6N","mobile":"j07VX","productsCountTag":"jbaYE","videoDurationTag":"_20YqT","luxeTag":"pBiuN","mobileIcon":"_2BpjD","desktopIcon":"aeRwX","text":"_30Dvy"};